/**
 * UndatedIndicator — badge showing the count of cards without a due date.
 * Returns null when the count is zero (hidden per Requirement 3.4).
 *
 * Validates: Requirements 3.3, 3.4
 */

import React from 'react';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export interface UndatedIndicatorProps {
  readonly count: number;
}

// ---------------------------------------------------------------------------
// Component
// ---------------------------------------------------------------------------

export function UndatedIndicator({
  count,
}: UndatedIndicatorProps): React.ReactElement | null {
  if (count === 0) {
    return null;
  }

  return (
    <span className="text-xs text-muted-foreground bg-muted rounded-full px-2 py-0.5">
      {count} undated
    </span>
  );
}
